import { default as EchoClass } from "laravel-echo";
import Pusher from "pusher-js";

import { api, baseApiUrl } from "./api";

export const Echo = new EchoClass({
  Pusher,
  broadcaster: "reverb",
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST.replace(
    /\{domain\}/g,
    window.location.hostname,
  ),
  wsPath: import.meta.env.VITE_REVERB_PATH,
  wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
  wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? "https") === "https",
  enabledTransports: ["ws", "wss"],
  authorizer: (channel: any) => {
    return {
      authorize: (socketId: string, callback: any) => {
        api
          .post(baseApiUrl + "/broadcasting/auth", {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => {
            callback(false, response.data);
          })
          .catch((error) => {
            callback(true, error);
          });
      },
    };
  },
});
